/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDealerDistinctions_seller$ref = any;
export type PdpSharedDealerDistinctions_seller = {
    readonly isDistinguished: boolean | null;
    readonly isRewardsTier2: boolean | null;
    readonly sellerTiers: {
        readonly isGoldTier: boolean | null;
        readonly isPlatinumTier: boolean | null;
        readonly sellerTierDataNotFound: boolean | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": PdpSharedDealerDistinctions_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDealerDistinctions_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isDistinguished",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": "isRewardsTier2",
            "name": "isAnchorListMember",
            "args": [
                {
                    "kind": "Literal",
                    "name": "listName",
                    "value": "SELLER_REWARDS_2"
                }
            ],
            "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "sellerTiers",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerTiers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isGoldTier",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isPlatinumTier",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellerTierDataNotFound",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeAssociations",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeAssociation",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceId",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '640fca573bc8eac07b61c4165dfbd0d8';
export default node;
